import { FormControl, FormLabel, TextField } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import LockIcon from '@mui/icons-material/Lock';
import React from 'react';

interface IProps {
  name?: string;
  id?: string;
  label?: React.ReactNode;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  type?: string;
  multiline?: boolean;
  rows?: number;
  minRows?: number;
  placeholder?: string;
  autoComplete?: string;
}

export const CustomTextField: React.FC<IProps> = ({ name, label, id, value, onChange, onBlur, onFocus, error, helperText, disabled, type = 'text', multiline, rows, minRows, placeholder, autoComplete }) => {
  const fieldId = id ?? (name ? `field-${name}` : undefined);

  return (
    <FormControl fullWidth error={error}>
      {label && (
        <FormLabel htmlFor={fieldId} error={error}>
          {label}
        </FormLabel>
      )}
      <TextField
        id={fieldId}
        className="psf-form__item psf-form__item-input"
        disabled={disabled}
        name={name}
        value={value ?? ''}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        error={error}
        helperText={helperText}
        type={type}
        multiline={multiline}
        rows={rows}
        minRows={minRows}
        placeholder={placeholder}
        autoComplete={autoComplete}
        slotProps={{
          input: {
            endAdornment: disabled ? (
              <InputAdornment position="end">
                <LockIcon sx={{ color: '#969696', fontSize: '18px' }} />
              </InputAdornment>
            ) : undefined,
          },
        }}
      />
    </FormControl>
  );
};
